import { render, staticRenderFns } from "./non-factory.vue?vue&type=template&id=55196168&scoped=true&"
import script from "./non-factory.vue?vue&type=script&lang=js&"
export * from "./non-factory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55196168",
  null
  
)

export default component.exports